<!-- Tutti i dati della simulazione: una scheda per gruppo, tabella etichetta / valore / unità -->
<h2 mat-dialog-title class="d-flex align-items-center">
  <mat-icon class="mr-2" color="primary" aria-hidden="true">list</mat-icon>
  {{ 'components.nerf-simulator.all_data' | translate }}
  @if (data.createdAt) {
    <small class="text-muted ml-auto">{{ data.createdAt | date:'d MMMM y, HH:mm':undefined:locale }}</small>
  }
</h2>
<mat-dialog-content>
  <mat-tab-group animationDuration="300ms">
    @for (group of groups; track group.titleKey) {
      <mat-tab [label]="(group.titleKey | translate) + ' (' + group.rows.length + ')'">
        <div class="table-container-rounded my-3">
          <table mat-table [dataSource]="group.rows" class="w-100 table-primary">
            <ng-container matColumnDef="label">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">{{ row.label }}</td>
            </ng-container>
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'generic.value' | translate }}</th>
              <td mat-cell *matCellDef="let row" class="text-right"><strong>{{ row.value }}</strong></td>
            </ng-container>
            <ng-container matColumnDef="unit">
              <th mat-header-cell *matHeaderCellDef>{{ 'generic.unit' | translate }}</th>
              <td mat-cell *matCellDef="let row" class="text-muted">{{ row.unit }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;"></tr>
          </table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" type="button" mat-dialog-close>{{ 'generic.buttons.close' | translate }}</button>
</mat-dialog-actions>
